import { useEffect, useRef } from "react";
import { FpsMeter } from "~/components/FpsMeter";
import { createScene, type SceneHandle } from "~/lib/scene";
import { useGraphStore } from "~/store/graphStore";

export function Viewer3D() {
  const outputs = useGraphStore((state) => state.outputs);
  const container = useRef<HTMLDivElement>(null);
  const handle = useRef<SceneHandle | null>(null);

  useEffect(() => {
    if (!container.current) return;

    const scene = createScene(container.current);
    handle.current = scene;

    return () => {
      handle.current = null;
      scene.dispose();
    };
  }, []);

  useEffect(() => {
    handle.current?.setOutputs(outputs);
  }, [outputs]);

  return (
    <div className="relative min-h-0 flex-1 bg-linear-to-br from-slate-900 to-indigo-950">
      <div ref={container} className="size-full" />
      {/* Top-right: the Help and Presets buttons are pinned to the top-left. */}
      <FpsMeter className="absolute top-2 right-2" />
    </div>
  );
}
